// React imports.
import React from "react";

//app imports
import {Assessment3VendorAssignedStatusEnum} from "../state";
import {Assessment3HHDataReceivedStatusEnum} from "../state";
import {Assessment3HHVendorsSelectedStatusEnum} from "../state";
import {Assessment3HHServedByVendorsProvidingDataStatusEnum} from "../state";
import {Assessment3RateOfReturnStatusEnum} from "../state";


const Assessment3MainTableRow = ({ state, fuel, rowClass }) => (
    <React.Fragment>
      <div className={"dwGridRow col1 "+ rowClass}>{fuel.description}</div>
        {state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholds === true &&
            <div className={"dwGridRow col2 blue-background "+ rowClass}>
                <span className={"requiredDash"}>*</span><input required id="numHouseholds" value={fuel.numHouseholds}
                    onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuel)} 
                    className="form-control " />
            </div>
        }
        {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholdsDataReceived1 === true
            && fuel.numHouseholds !== 0) &&
            <div className={"dwGridRow col3 yellow-background "+ rowClass}>
                <span className={"requiredDash"}>*</span><input required id="numHouseholdsDataReceived" value={fuel.numHouseholdsDataReceived}
                    onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuel)} 
                    className="form-control " />
            </div>
        }

        {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholdsDataReceived1 === true
          && fuel.numHouseholds === 0)&&
            <div className={"dwGridRow  col3 "+ rowClass}>
                N/A
            </div>
        }

        {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showpercentHouseholdsDataReceived === true
            && fuel.numHouseholds !== 0) &&
            <React.Fragment>
                {(fuel.dataReceivedStatus ==Assessment3HHDataReceivedStatusEnum.OverTargetNoIssues)
                    &&<div className={"dwGridRow col4 green-background "+ rowClass}>{fuel.percentHouseholdsDataReceived}</div>
                }
                {(fuel.dataReceivedStatus ===Assessment3HHDataReceivedStatusEnum.NotMeetTarget)
                    &&<div className={"dwGridRow col4 red-background "+ rowClass}>{fuel.percentHouseholdsDataReceived}</div>
                }
            </React.Fragment>
        }
        {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showpercentHouseholdsDataReceived === true
          && fuel.numHouseholds === 0)&&
            <div className={"dwGridRow  col4 "+ rowClass}>
                N/A
            </div>
        }


        {/* Connor requested these status values also.  We don't have any information about model plan in the database
         * Potential Issue – You did not report a number of assisted households for {INSERT FUEL} even though your model plan indicates you serve households that heat with this fuel.
         * Potential Issue – You did not report the number of households for whom you received data for this fuel type even though your model plan indicates you serve households with this main heating fuel.
         */}




        {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showDataReceivedStatus === true
            && fuel.numHouseholds !== 0) &&
            <React.Fragment>
                {(fuel.dataReceivedStatus ==Assessment3HHDataReceivedStatusEnum.OverTargetNoIssues)
                    &&<div className={"dwGridRow col5 green-background "+ rowClass}>
                        <span>
                            <strong>No Issue Flagged –</strong>
                            You have received data from at
                            least  {fuel.targetPercentHouseholdsCoveredString}  of your  {fuel.description}  households.
                        </span>
                      </div>
                }
                {(fuel.dataReceivedStatus ===Assessment3HHDataReceivedStatusEnum.NotMeetTarget)
                    &&<div className={"dwGridRow col5 red-background "+ rowClass}>
                        <span>
                            <strong>Potential Issue –</strong>
                            You have not received data from at least  {fuel.targetPercentHouseholdsCoveredString}  of your  {fuel.description}  households.
                        </span>
                      </div>
                }
                {(fuel.numHouseholds =='')
                    &&<div className={"dwGridRow col5 red-background "+ rowClass}>
                        <span>
                            <strong>Potential Issue –</strong>
                            You have not received data from at least  {fuel.targetPercentHouseholdsCoveredString}  of your  {fuel.description}  households.
                        </span>
                      </div>
                }
            </React.Fragment>
        }

        {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showDataReceivedStatus === true
          && fuel.numHouseholds === 0)&&
            <div className={"dwGridRow  col5 "+ rowClass}>
                <strong>N/A –</strong>
                You indicated that you do not serve households that heat
                with  {fuel.description}.
            </div>
        }

    </React.Fragment>
);

export default Assessment3MainTableRow;
